import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OtQuotationListItem extends SearchModelBase {
    id: number = 0;
    quoteNo: string = '';
    quoteDate: string | null = null;
    fromQuoteDate: string | null = null;
    toQuoteDate: string | null = null;
    operator: string = '';
    customer: number = 0;
    customerName: string = '';
    cargoDesc: string = '';
    pickupFrom: string = '';
    deliveryTo: string = '';
    custRefNo: string = '';
    ctnrType: string = '';
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    status: string = '';
    validDate: string | null = null;
    fromValidDate: string | null = null;
    toValidDate: string | null = null;
    sManID: string = '';
    contactName: string = '';
    contact: number = 0;
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    cntrType: string = '';
    salesperson: string = '';
    specialMemo: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'quoteDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 2, text: 'Quotation #', width: 100, dataIndex: 'quoteNo', defaultColumnFocus: true }),
        XCol.Create({ col: 3, text: 'Quote By', width: 80, dataIndex: 'operator' }),
        XCol.Create({ col: 4, text: 'Valid By', width: 75, dataIndex: 'validDate', type: XCol.XCellType.Date }),
        XCol.Create({ col: 5, text: 'Customer', width: 120, dataIndex: 'customerName' }),
        XCol.Create({ col: 6, text: 'Contact', width: 120, dataIndex: 'contactName' }),
        XCol.Create({ col: 7, text: 'Customer Ref. #', width: 150, dataIndex: 'custRefNo' }),
        XCol.Create({ col: 8, text: 'Pickup From', width: 120, dataIndex: 'pickupFrom' }),
        XCol.Create({ col: 9, text: 'Delivery To', width: 120, dataIndex: 'deliveryTo' }),
        XCol.Create({ col: 10, text: 'Cargo Description', width: 120, dataIndex: 'cargoDesc' }),
        XCol.Create({ col: 11, text: 'Container Type', width: 80, dataIndex: 'cntrType' }),
        XCol.Create({ col: 12, text: 'Salesperson', width: 100, dataIndex: 'salesperson' }),
        XCol.Create({ col: 13, text: 'Special Instruction', width: 120, dataIndex: 'specialMemo' }),
        XCol.Create({ col: 14, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime }),
        XCol.Create({ col: 15, text: 'Create by', width: 80, dataIndex: 'u1ID' }),
        XCol.Create({ col: 16, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime }),
        XCol.Create({ col: 17, text: 'Update by', width: 80, dataIndex: 'u2ID' }),
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return OtQuotationListItem.ExportCollection;
    };

    public static OrderBy = { orderBy: OtQuotationListItem.prototype.u1Date, orderByAscending: false };

    public static formatData(data: OtQuotationListItem[]) {
        return data.map((d: OtQuotationListItem) => ({
            ...d,
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
        quoteDate: { from: 'fromQuoteDate', to: 'toQuoteDate' },
        validDate: { from: 'fromValidDate', to: 'toValidDate' },
        u1Date: { from: 'fromU1Date', to: 'toU1Date' },
        u2Date: { from: 'fromU2Date', to: 'toU2Date' },
    }

}